module.exports = __webpack_public_path__ + "PERUVIANhome-12.c33e721e.png";